<template>
  <div class="card col s12 m6 l6 animated zoomIn">
    <div class="card-content">
      <h6>Welcome, please enter your phone number to continue</h6>
      <form id="formLogin" v-if="!resetView">
        <div class="row">
          <div class="input-field col s12 m12">
            <input id="receiver" type="text" v-model="fields.phone" autofocus />
            <label
              for="phone"
              class="active"
              v-if="fields.welcomeOption == 'signin'"
              >Phone number / Username</label
            >
            <label for="phone" class="active" v-else>Phone number</label>
          </div>
        </div>
        <div class="row" v-if="fields.welcomeOption == 'signin'">
          <div class="input-field col s12 m12">
            <i
              class="material-icons prefix"
              @click="reveal = !reveal"
              style="cursor: pointer;"
              >{{ reveal ? 'visibility_off' : 'visibility' }}</i
            >
            <input id="pass" :type="reveal ? 'text' : 'password'" v-model="fields.password" />
            <label for="pass" class="active">Password</label>
          </div>
          <div class="col s12 m12">
            <label
              style="float: left; cursor: pointer"
              @click.prevent="resetView = true"
            >
              <span>Forgot Password? </span>
            </label>
          </div>
        </div>
        <div class="form-field">
          <div v-if="loading">
            <img src="ui/img/loading.svg" alt="Time Loader" />
            <p><i>Loading...</i></p>
          </div>
          <div v-else>
            <button
              id="loginBtn"
              class="btn-large waves-effect green darken-2 waves-dark"
              style="width:100%;"
              @click.prevent="fields.welcomeOption !== 'signin' ? proceed() : proceedSigin()"
            >
              PROCEED
            </button>
            <hr />
            <button
              class="btn-large waves-effect green darken-2 waves-dark"
              style="width:100%;"
              @click.prevent="login('vendor')"
            >
              BECOME A MERCHANT
            </button>
          </div>
        </div>
      </form>
      <form id="reset" v-else>
        <div class="row">
          <div class="input-field col s12 m12">
            <input type="text" v-model="username" />
            <label for="email">Phone number</label>
          </div>
        </div>
        <div class="form-field">
          <div v-if="loading">
            <img src="ui/img/loading.svg" alt="Time Loader" />
            <p><i>Loading...</i></p>
          </div>
          <div v-else>
            <button
              id="resetBtn"
              class="btn-large waves-effect green darken-2 waves-dark"
              style="width:100%;"
              @click.prevent="reset()"
            >
              Reset Password
            </button>
            <br />
            <br />
            <button
              id="resetBtn"
              class="btn-large waves-effect red waves-dark"
              style="width:100%;"
              @click.prevent="resetView = false"
            >
              <i class="fa fa-arrow-left" aria-hidden="true"></i> Back to Login
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Welcome',
  created() {
    // this.clearSession()
  },
  mounted() {
    if (localStorage.getItem('phone') !== null) {
      $('#receiver').val(localStorage.getItem('phone'))
      this.fields.phone = localStorage.getItem('phone')
      // this.getLastTransaction()
    }
    // M.updateTextFields();
  },
  data() {
    return {
      loading: false,
      reveal: false,
      resetView: false,
      fields: {
        relocate: 'login',
        action: 'login',
        welcomeOption: 'guest'
      },
      guestField: {
        action: 'last_transaction'
      },
      validate: {
        action: 'validate_phone'
      },
      username: ''
    }
  },
  methods: {
    login(option) {
      document.getElementById('myNav').style.width = '100%'
      this.$emit('modal-option', option)
    },
    async proceed() {
      if (this.ValidateData()) {
        this.loading = true
        this.reveal = false
        const validPhone = await this.validatePhone()
        if (validPhone) {
          this.fields.welcomeOption = 'signin'
          this.loading = false
        } else {
          M.toast({ html: 'Welcome to iRecharge', classes: 'success' })
          // set the required status and session timeout
          this.setGuestStatus()
          // check if last transaction exist
          var checkTransaction = this.lastTransactionExist()
          if (checkTransaction) {
            // proceed to page with browser last transaction
            // proceed to login guest with transaction history on browser
            location.reload()
          } else {
            // proceed to fetch last transaction
            this.getLastTransaction()
          }
        }
      }
    },
    async validatePhone() {
      var result = null
      this.validate.passcode = this.hash(this.fields.phone.toString())
      this.validate.phone = this.fields.phone
      // Confirm if number is an iRecharge user already
      await this.axios
        .post(
          'https://irecharge.com.ng/api/misc/validate_phone.php',
          this.validate
        )
        .then(response => {
          if (response.data.status == '0') {
            // This phone number is an iRecharge User
            localStorage.setItem('user', true)
            result = true
          } else {
            // set the limits for transaction as a guest
            localStorage.setItem('attempts', 1)
            localStorage.setItem('user', false)
            result = false
          }
          if (response.data.message == 'Unauthorized Access') {
            $('.toast').hide()
            M.toast({
              html: 'We could not verify, please try again.',
              classes: 'error'
            })
            this.loading = false
          }
        })
        return result
    },
    proceedSigin() {
      if(this.fields.password) {
        // set form data
        this.loading = true
        this.reveal = false
        var bodyFormData = new FormData()
        bodyFormData.set('relocate', 'login')
        bodyFormData.set('action', 'login')
        bodyFormData.set('inputEmail', this.fields.phone)
        bodyFormData.set('inputPassword', this.fields.password)
        this.axios
          .post('control1.php', bodyFormData)
          .then(response => {
            if (response.data.status == 1) {
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'success' })
              // userType 1 = user
              // userType 2 = guest
              localStorage.setItem('phone', response.data.phone)
              localStorage.setItem('username', response.data.username)
              localStorage.setItem('userType', 1)
              // Status 1 = Don't show the welcome message
              // Status 2 = Always show the welcome message
              if (response.data.is_vendor) {
                // Status 1 = Don't show the welcome message
                localStorage.setItem('status', 1)
                localStorage.removeItem('power')
                localStorage.removeItem('airtime')
                localStorage.removeItem('data')
                localStorage.removeItem('tv')
                window.location.assign('profile.php')
              }
              localStorage.setItem('status', 1) // 2 always show the welcome message, 1 don't show the welcome message
              sessionStorage.setItem('status', 1) // for sessionClose
              this.getLastTransaction()
            } else {
              this.loading = false
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'info' })
            }
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({
              html: 'Could not send request, check network.',
              classes: 'error'
            })
            this.loading = false
          })
      }
    },
    setGuestStatus() {
      // userType 1 = user
      // userType 2 = guest
      localStorage.setItem('phone', this.fields.phone)
      localStorage.setItem('userType', 2)
      // Status 1 = Don't show the welcome message
      // Status 2 = Always show the welcome message
      localStorage.setItem('status', 1)
      sessionStorage.setItem('status', 1) // for sessionClose
    },
    lastTransactionExist() {
      if (localStorage.getItem('phone') != null) {
        if (this.fields.phone == localStorage.getItem('phone')) {
          var power = localStorage.getItem('power')
          var tv = localStorage.getItem('tv')
          var airtime = localStorage.getItem('airtime')
          var data = localStorage.getItem('data')
          if (
            power !== null &&
            tv !== null &&
            airtime !== null &&
            data !== null
          ) {
            return true // all last transactions exist
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    setLastTransaction(transactions) {
      localStorage.setItem('power', JSON.stringify(transactions[0]))
      localStorage.setItem('tv', JSON.stringify(transactions[1]))
      localStorage.setItem('airtime', JSON.stringify(transactions[2]))
      localStorage.setItem('data', JSON.stringify(transactions[3]))
    },
    getLastTransaction() {
      $('.toast').hide()
      M.toast({ html: 'Fetch your last transaction...', classes: 'success' })
      this.loading = true
      this.guestField.passcode = this.hash(this.fields.phone.toString())
      this.guestField.phone = this.fields.phone
      this.axios
        .post(
          'https://irecharge.com.ng/api/misc/last_trans.php',
          this.guestField
        )
        .then(response => {
          if (response.data.status == '0') {
            // Set the last transaction for each service
            this.setLastTransaction(response.data.transactions)
          }
          if (response.data.message == 'Unauthorized Access') {
            $('.toast').hide()
            M.toast({
              html: 'We could not verify, please try again.',
              classes: 'error'
            })
          }
          location.reload()
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({
            html: 'Failed fetching last transaction',
            classes: 'error'
          })
          this.loading = false
        })
    },
    ValidateData() {
      if (this.fields.phone) {
        if (this.fields.welcomeOption) {
          return true
        } else {
          $('.toast').hide()
          M.toast({ html: 'Select an option', classes: 'info' })
        }
      } else {
        $('.toast').hide()
        M.toast({ html: 'Phone field is required!', classes: 'info' })
      }
    },
    ValidateReset() {
      if (this.username) {
        return true
      } else {
        $('.toast').hide()
        M.toast({ html: 'Field is required!', classes: 'info' })
      }
    },
    reset() {
      if (this.ValidateReset()) {
        this.loading = true
        // set form data
        var bodyFormData = new FormData()
        bodyFormData.set('action', 'recover_login_new')
        bodyFormData.set('username', this.username)
        this.axios
          .post('control1.php', bodyFormData)
          .then(response => {
            if (response.data.status == 0) {
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'success' })
              this.resetView = false
              this.loading = false
            } else {
              this.loading = false
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'info' })
            }
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({
              html: 'Could not send request, check network.',
              classes: 'error'
            })
            this.loading = false
          })
      }
    },
    clearSession() {
      localStorage.setItem('userType', 2)
      localStorage.removeItem('status')
      localStorage.removeItem('attempts')
      sessionStorage.removeItem('status')
      localStorage.removeItem('tv')
      localStorage.removeItem('power')
      localStorage.removeItem('data')
      localStorage.removeItem('airtime')
      localStorage.removeItem('expire')
      localStorage.removeItem('timestamp')
      localStorage.removeItem('user')
      localStorage.removeItem('email')
      localStorage.removeItem('username')
    },
    hash(ref) {
      let passcode = '123NDSx'
      let encrypted = CryptoJS.HmacSHA512(ref, passcode)
      return encrypted.toString()
    }
  }
}
</script>
<style scoped>
label {
  font-size: 1rem;
  color: #9e9e9e;
  font-weight: bold;
}
.card-content {
  padding: 24px 24px;
}
.card .card-action {
  padding: 6px 24px;
}
</style>
